import { GET_BANNERS, GET_BANNER, GET_HOME_BANNERS } from '../actions/types';

import { INITIAL_STATE } from '../states/states';

export default (state = INITIAL_STATE.BANNERS, action) => {
  switch (action.type) {
    case GET_BANNERS:
      return { ...state, banners: action.payload };
    case GET_BANNER:
      return { ...state, bannerInfo: action.payload };
    case GET_HOME_BANNERS:
      return { ...state, homeBanners: action.payload };
    default:
      return state;
  }
};
